import React from "react";
import axios from "axios";
import { useUserContext } from "../../../contexts/UserContext";

export default function ChargeDeleteModal({ open, charge, onClose, onDeleted }) {
  const { getAuthHeaders } = useUserContext();

  if (!open || !charge) return null;

  const handleDelete = async () => {
    try {
      await axios.delete(`http://localhost:4000/delete/charges/${charge._id}`, {
        headers: getAuthHeaders(),
      });
      onDeleted();
      onClose();
    } catch (err) {
      console.error("Erreur suppression charge", err);
      alert("Erreur suppression charge : " + err.response?.data?.message || err.message);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card glass danger">
        <h3>Supprimer la charge</h3>
        <p>Voulez-vous vraiment supprimer cette charge : <strong>{charge.description}</strong> ?</p>
        <div className="modal-actions">
          <button className="btn-danger" onClick={handleDelete}>Supprimer</button>
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}